export const customers = [
    {
        title: 'Экономия',
        rows: [
            'Средняя экономия — 17%',
            'В среднем 4 участника на закупку',
            'Анализ НМЦ',
            'Мониторинг цен',
            'Система приглашения участников',
        ],
        icon: 'wallet',
        backgroundColor: 'linear-gradient(360deg, #2193B0 4.08%, #6DD5ED 100%)',
    },
    {
        title: 'Простота',
        rows: [
            'Регистрация без лишней бюрократии',
            'Удобный интуитивный интерфейс',
            'Создание закупки за 3 минуты',
        ],
        icon: 'emoji',
        backgroundColor:
            'linear-gradient(180deg, #AAD485 0%, #AAD485 2%, #6CBE45 100%)',
    },
    {
        title: 'Поддержка',
        rows: [
            '2 личных менеджера по работе на ЭТП',
            'Бесплатная юридическая поддержка',
            'Индивидуальное обучение и семинары',
        ],
        icon: 'phone',
        backgroundColor: 'linear-gradient(0deg, #9687C0 0%, #ECBAD6 100%)',
    },
    {
        title: 'Индивидуальность',
        rows: [
            'Создание торговых секций закупки',
            'Интеграция с внутренними системами заказчика',
            'Создание дополнительного функционала',
        ],
        icon: 'circle',
        backgroundColor:
            'linear-gradient(360deg, #EC6EA0 0%, #EB8C69 99%, #EB8C69 100%)',
    },
    {
        title: 'Универсальность',
        rows: [
            'Проведение всех торговых процедур, в том числе и закупки у СМСП',
            'Инновационный электронный магазин',
            'Конструктор способов закупки',
        ],
        icon: 'element',
        backgroundColor:
            'linear-gradient(360deg, #B8860B -68.75%, rgba(255, 204, 0, 0.5) 168.75%)',
    },
    {
        title: 'Безопасность',
        rows: [
            'Ролевая система прав доступа',
            'Логирование всех действий',
            'Защита всех данных',
        ],
        icon: 'security',
        backgroundColor: 'linear-gradient(0deg, #2C3E50 0%, #828282 100%)',
    },
    {
        title: 'Эффективность',
        rows: [
            'Гибкая система отчётов',
            'Настраиваемая аналитика',
            'Проверка надёжности поставщика',
        ],
        icon: 'star',
        backgroundColor: 'linear-gradient(180deg, #F3D072 0%, #F79A83 98.75%)',
    },
];
